module.exports = __webpack_public_path__ + "static/img/industry2.742d356.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/industry2.png
// module id = CKrQ
// module chunks = 0